import React, { useState } from 'react';
import { Table, Pagination } from 'rsuite';
import './onboarded-accounts.scss';
import 'rsuite/dist/rsuite.min.css';
import { ActionLink } from '../../../atoms';
import { AccountDetailsOverview } from '../../molecules';
import { default as t } from '../../../../utils/i18n';

function OnboardedAccounts({ accounts, changeLimit, changePage }) {
  const { Column, HeaderCell, Cell } = Table;
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [searchItem, setSearchItem] = useState('');
  const triggerRef = React.useRef();
  const [openDetailsSliderModal, setOpenDetailsSliderModal] = useState(false);
  const [acId, setAcId] = useState(null);

  const getWidth = (value = 6) => {
    return window.innerWidth / value;
  };

  const handleChangeLimit = (dataKey, searchItem='') => {
    setPage(1);
    setLimit(dataKey);
    changeLimit(1, searchItem, dataKey);
  };

  const pageChange = page => {
    setPage(page);
    changePage(page, searchItem, limit);
  };

  const handleAdd = key => {
    triggerRef.current.close();
  };

  const handleOnView = (e, rowData) => {
    e.preventDefault();
    setAcId(rowData?.accountId);
    setOpenDetailsSliderModal(true);
  };

  const StatusCell = ({ rowData, onChange, dataKey, ...props }) => (
    <Cell {...props}>
      <div>
        {rowData[dataKey] === 1 ? (
          <span>{t('admin.status.active')}</span>
        ) : rowData[dataKey] === -1 ? (<span>{t('In progress')}</span>): (
          <span>{t('admin.status.inactive')}</span>
        )}
      </div>
    </Cell>
  );

  const handleOpenSliderModal = isDeleted => {
    if (isDeleted) {
      handleChangeLimit(10);
    }
    setOpenDetailsSliderModal(!openDetailsSliderModal);
  };

  return (
    <div>
      <div>
        <Table
          autoHeight
          data={accounts?.onboardedOwnedAdAccounts}
          bordered
          cellBordered
          className="admin-table"
        >
          <Column width={getWidth(4)}>
            <HeaderCell>{t('admin.account.id')}</HeaderCell>
            <Cell dataKey="accountId" />
          </Column>

          <Column width={getWidth(4)}>
            <HeaderCell>{t('admin.ac.name')}</HeaderCell>
            <Cell dataKey="accountName" />
          </Column>

          <Column width={getWidth()}>
            <HeaderCell>{t('admin.ac.onboardstatus')}</HeaderCell>
            <StatusCell dataKey="status" />
          </Column>
          <Column width={getWidth()}>
            <HeaderCell></HeaderCell>
            <Cell align="center">
              {rowData => (
                <span className="view-details">
                  <i className="eva  eva-arrow-forward-outline"></i>
                  <ActionLink
                    value={t('admin.bm.details.view')}
                    handleClick={e => handleOnView(e, rowData)}
                  />
                </span>
              )}
            </Cell>
          </Column>
        </Table>
      </div>
      <div className="pagination-div">
        <span>{t('reports.per.page')}</span>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          layout={['-', 'limit', '|', 'pager']}
          total={accounts?.pagination?.totalRecords}
          limitOptions={[10, 15]}
          limit={limit}
          activePage={page}
          onChangePage={page => {
            pageChange(page);
          }}
          onChangeLimit={handleChangeLimit}
        />
      </div>
      {openDetailsSliderModal && (
        <AccountDetailsOverview
          insightDetails={openDetailsSliderModal}
          handleModalBackClick={handleOpenSliderModal}
          accountID={acId}
        />
      )}
    </div>
  );
}
export default OnboardedAccounts;
